/* ============================================================
   VYARA® — BASE JS  (assets/vyara-base.js)
   Loaded on every page via layout/theme.liquid
   ============================================================ */

(function () {
  'use strict';

  /* ── CURSOR ── */
  var dot  = document.getElementById('vyara-cursor-dot');
  var ring = document.getElementById('vyara-cursor-ring');
  var car  = document.getElementById('vyara-racecar');

  if (dot && ring) {
    var mx = 0, my = 0;
    var rx = 0, ry = 0;
    var prevX = 0, prevY = 0;
    var carAngle = 0, targetAngle = 0;

    document.addEventListener('mousemove', function (e) {
      mx = e.clientX;
      my = e.clientY;

      dot.style.left = mx + 'px';
      dot.style.top  = my + 'px';

      var dx = mx - prevX, dy = my - prevY;
      if (Math.abs(dx) > 1 || Math.abs(dy) > 1) {
        targetAngle = Math.atan2(dy, dx) * (180 / Math.PI);
      }
      prevX = mx; prevY = my;
    });

    (function animLoop() {
      rx += (mx - rx) * 0.12;
      ry += (my - ry) * 0.12;
      ring.style.left = rx + 'px';
      ring.style.top  = ry + 'px';

      if (car) {
        carAngle += (targetAngle - carAngle) * 0.1;
        car.style.left      = (rx - 40) + 'px';
        car.style.top       = (ry + 20) + 'px';
        car.style.transform = 'rotate(' + carAngle + 'deg)';
      }
      requestAnimationFrame(animLoop);
    })();

    /* scale on hover */
    document.addEventListener('mouseover', function (e) {
      if (e.target.closest('a, button, [data-cursor-hover]')) {
        dot.style.transform  = 'translate(-50%,-50%) scale(2)';
        ring.style.borderColor = 'var(--vp)';
        ring.style.opacity = '1';
      }
    });
    document.addEventListener('mouseout', function (e) {
      if (e.target.closest('a, button, [data-cursor-hover]')) {
        dot.style.transform  = 'translate(-50%,-50%) scale(1)';
        ring.style.borderColor = 'var(--vl)';
        ring.style.opacity = '0.7';
      }
    });
  }

  /* ── TOAST ── */
  window.vyaraToast = function (msg) {
    var t = document.getElementById('vyara-toast');
    if (!t) return;
    t.innerHTML = '<span style="color:var(--vp);margin-right:6px">✓</span>' + msg;
    t.classList.add('is-visible');
    clearTimeout(t._timer);
    t._timer = setTimeout(function () {
      t.classList.remove('is-visible');
    }, 2400);
  };

  /* ── SCROLL REVEAL ── */
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target); /* fire once only */
      }
    });
  }, { threshold: 0.08 });

  document.querySelectorAll('.vyara-fade-up').forEach(function (el) {
    observer.observe(el);
  });

  /* ── MOBILE NAV TOGGLE ── */
  var mobToggle = document.querySelector('.vyara-nav__mob-toggle');
  var navLinks  = document.querySelector('.vyara-nav__links');
  if (mobToggle && navLinks) {
    mobToggle.addEventListener('click', function () {
      var open = navLinks.classList.toggle('is-open');
      mobToggle.setAttribute('aria-expanded', open.toString());
    });
  }

  /* ── WISHLIST HEART TOGGLE (UI only) ── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wish-toggle]');
    if (!btn) return;
    var liked = btn.getAttribute('data-liked') === 'true';
    btn.textContent = liked ? '🤍' : '❤️';
    btn.setAttribute('data-liked', (!liked).toString());
    btn.classList.toggle('is-liked', !liked);
    if (!liked) vyaraToast('Added to wishlist ❤️');
  });

})();
